<template>
  <el-container class="BomView">
    <div>
      <el-input v-model="data.name" readonly>
        <template slot="prepend">품목명</template>
      </el-input>
    </div>
    <el-main class="p-0 pb-default flex of-auto" style="max-height: 400px;">
      <div class="flex-fixed" style="width: 500px;">
        <ABomTree
          ref="tree"
          :id="this.data.id"
          :specifications="[]"
          @completed="handleCompleteBomTree"
        />
      </div>
      <div class="flex-auto">
        <ABomTable :production="production" :material="material" />
      </div>
    </el-main>
    <el-footer>
      <el-button class="close-button" @click="closeDialog">{{$t('button.close')}}(Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";

export default {
  name: "BomView",
  mixins: [form],
  data() {
    return {
      production: [],
      material: []
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleCompleteBomTree(result) {
      this.production = result.production;
      this.material = result.material;
    }
  }
};
</script>
